import Cookies from "js-cookie";

const PermissionsRequired = (strgroups) => {
    // Handle direct boolean check usage (new way)
    if (typeof strgroups === 'string' && !strgroups.includes("&&")) {
        if (!Cookies.get("access")) {
            return false;
        }
        
        const useraccess = JSON.parse(Cookies.get("access")) || [];
        const grouplist = strgroups.split("|");
        
        // Keep the exact same logic as before
        return useraccess.map((access) => grouplist.includes(access)).reduce((a, b) => a || b, false);
    }
    
    // Original logic for component rendering (unchanged)
    if (Cookies.get("userid")) {
        if (!Cookies.get("access")) {
            return true;
        }
        const useraccess = JSON.parse(Cookies.get("access")) || [];
        const grouplist = strgroups.split("|");
    
        return useraccess.map((access) => grouplist.includes(access)).reduce((a, b) => a || b);
    } else {
        return null;
    }
};

export default PermissionsRequired;